import { forwardRef, useRef, useImperativeHandle, useEffect } from "react";

const RichEditor = forwardRef(function RichEditor({ initialHTML, onChange, placeholder, testId }, ref) {
  const elRef = useRef(null);
  useImperativeHandle(ref, () => elRef.current, []);

  useEffect(() => {
    if (elRef.current) {
      elRef.current.innerHTML = initialHTML || "";
    }
    // Force tag-based markup (<b>/<i>) instead of inline CSS spans so formatting
    // is preserved on export, and make Enter create <p> blocks.
    try {
      document.execCommand("styleWithCSS", false, false);
      document.execCommand("defaultParagraphSeparator", false, "p");
    } catch (_) { /* non-standard, best effort */ }
    // Set content once on mount; parent remounts via key on chapter change.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div
      ref={elRef}
      data-testid={testId}
      contentEditable
      suppressContentEditableWarning
      spellCheck
      onInput={() => onChange(elRef.current.innerHTML)}
      data-placeholder={placeholder}
      className="rich-editor editor-textarea w-full min-h-[50vh] bg-transparent text-slate-200 outline-none"
    />
  );
});

export default RichEditor;
